module.exports = __webpack_public_path__ + "static/img/Will-McDowell-White.ca13cb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Will-McDowell-White.jpg
// module id = QAm4
// module chunks = 1